import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

import './HeatmapButton.scss';

export default function HeatmapButton({ isHeatmapAvailable, isHeatmapDisabled, onHeatmapButtonClick, buttonSize = 'small' }) {
  if (!isHeatmapAvailable) {
    return null;
  }

  return (
    <ButtonWithIcon
      id="heatmap"
      type="tertiary"
      size={buttonSize}
      disabled={isHeatmapDisabled}
      aria-disabled={isHeatmapDisabled}
      aria-label="Bioactivity Visualization"
      className="result-toolbar-heatmap-button e2e-heatmap"
      sprite="MatrixView"
      iconRight
      onClick={() => {
        onHeatmapButtonClick();
      }}>
      Bioactivity Visualization
    </ButtonWithIcon>
  );
}

HeatmapButton.propTypes = {
  isHeatmapDisabled: PropTypes.bool.isRequired,
  isHeatmapAvailable: PropTypes.bool.isRequired,
  onHeatmapButtonClick: PropTypes.func.isRequired,
  buttonSize: PropTypes.string,
};
